<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    // localStorage.setItem('TWO_ONE_AGE', false);
    // this.$store.commit('init')
    const userInfo = localStorage.getItem("TIANYUE_USER_INFO")
    if (userInfo) this.$store.commit("updateUserInfo", JSON.parse(userInfo))
  }
}
</script>

<style lang="scss" scoped>
// #app {
//   // width: 100vw;
//   height: 100vh;
//   // overflow: hidden;
//   overflow-y: auto;
//   background-color: #020308;
//   // overflow: hidden;
// }
</style>

<style lang="scss">
@import '@/assets/scss/global.scss';

@font-face {
  font-family: cfont1;
  src: url('~@/assets/font/Poppins-Bold.ttf');
}
</style>
